import { isEqual } from 'lodash';

export const buildPatch = <P extends object>(
  current: object,
  initial: object | undefined,
  keys: ReadonlyArray<keyof P & string>
): Partial<P> => {
  const cur = current as Record<string, unknown>;
  const init = initial as Record<string, unknown> | undefined;
  return keys.reduce((res, key) => {
    if (key in cur && !isEqual(cur[key], init?.[key])) {
      (res as Record<string, unknown>)[key] = cur[key];
    }
    return res;
  }, {} as Partial<P>);
};